import {
  ColorType,
  Loading,
  Sizes,
} from '@sede-enterprise/shell-ds-react-framework';
import { Check } from '@sede-enterprise/shell-ds-react-framework/build/esm/components/Icon/components';
import { ICompanyListIconProps } from 'components/CompanyList/CompanyList.types';

const CompanyListIcon = ({
  loading,
  disabled,
  selected,
  company,
}: ICompanyListIconProps) => {
  if (loading) {
    return (
      <Loading
        size={Sizes.Small}
        data-testid="loading-spinner"
        type={ColorType.onSentiment}
      />
    );
  }

  if (!loading && company.node.id === selected) {
    return <Check data-testid="checkmark" height={24} width={24} />;
  }

  return <></>;
};

export default CompanyListIcon;
